export const SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES = 'mr-3 inline-block h-10 w-10 shrink-0 rounded-2 object-cover';

export const SHARED_PANEL_ITEM_CLASS_NAMES = 'px-2.5 py-1.5 rounded-4 mx-1.5 transition-all duration-200';
